/** Motor private (direct customer) — product 3437, product group 70 */

export const MOTOR_PROD_ID = 3437;
export const MOTOR_PRODUCT_GROUP = 70;

/** GIS PolicyDTO — subclass / binder for motor private (override via env if UAT differs). */
export const MOTOR_GIS_SUBCLASS_CODE = Number(process.env.VUE_APP_MOTOR_GIS_SUBCLASS_CODE) || 700;
export const MOTOR_GIS_BINDER_CODE = Number(process.env.VUE_APP_MOTOR_GIS_BINDER_CODE) || 20224997;

export const MOTOR_COVER_COMPREHENSIVE = 101;
export const MOTOR_COVER_TPO = 106;

export const MOTOR_MIN_COMP_VALUE = 500000;

export const MOTOR_COVER_OPTIONS = [
  {
    id: 'comprehensive',
    covertypeId: MOTOR_COVER_COMPREHENSIVE,
    label: 'Comprehensive',
    description: 'Own damage, theft, fire, and third-party liability.',
  },
  {
    id: 'tpo',
    covertypeId: MOTOR_COVER_TPO,
    label: 'Third Party Only',
    description: 'Third-party liability as required by law.',
  },
];
